import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import categorySlice from './slices/categorySlice';
import articleSlice from './slices/articleSlice';
import heroContentSlice from './slices/heroContentSlice';
import carouselSlice from './slices/carouselSlice';
import courseSlice from './slices/courseSlice';
import universitySlice from './slices/universitySlice';
import adminSlice from './slices/adminSlice';
import reportsSlice from './slices/reportsSlice';
import settingsSlice from './slices/settingsSlice';
import uploadSlice from './slices/uploadSlice';
import contactSlice from './slices/contactSlice';
import documentSlice from './slices/documentSlice';
import notificationSlice from './slices/notificationSlice';
import advertisementSlice from './slices/advertisementSlice';
import configSlice from './slices/configSlice';
import commentSlice from './slices/commentSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    category: categorySlice,
    article: articleSlice,
    heroContent: heroContentSlice,
    carousel: carouselSlice,
    course: courseSlice,
    university: universitySlice,
    admin: adminSlice,
    reports: reportsSlice,
    settings: settingsSlice,
    upload: uploadSlice,
    contact: contactSlice,
    document: documentSlice,
    notification: notificationSlice,
    advertisement: advertisementSlice,
    config: configSlice,
    comment: commentSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
